<app-query-editor
  [query]="(feed$ | async).query"
  [objectTypeId]="(feed$ | async).object_type_id"
></app-query-editor>
